var o = Object.defineProperty;
var a = (r, n, t) => n in r ? o(r, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[n] = t;
var u = (r, n, t) => a(r, typeof n != "symbol" ? n + "" : n, t);
import { HttpClient as c, httpClient as e } from "../../httpClient.js";
class p extends c {
  constructor() {
    super(...arguments);
    u(this, "endpoint", "/courses");
  }
  async get(t) {
    return e.get(`${this.endpoint}/${t}`);
  }
  async list(t) {
    return e.get(this.endpoint, { params: t });
  }
  async getAvailable(t) {
    return e.get(`${this.endpoint}/available`, {
      params: t
    });
  }
  async search(t, s = 1, i) {
    return e.get(this.endpoint, {
      params: {
        searchText: t,
        page: s,
        excludeIds: i
      }
    });
  }
  async create(t) {
    return e.post(this.endpoint, t);
  }
  async update(t, s) {
    return e.put(`${this.endpoint}/${t}`, s);
  }
  async getLessons(t) {
    return e.get(`${this.endpoint}/${t}/lessons`);
  }
  async getObjectives(t) {
    return e.get(`${this.endpoint}/${t}/objectives`);
  }
  async getStudents(t) {
    return e.get(`${this.endpoint}/${t}/students`);
  }
  async getInstructors(t) {
    return e.get(`${this.endpoint}/${t}/instructors`);
  }
  async addInstructor(t, s) {
    return e.post(`${this.endpoint}/${t}/instructors`, s);
  }
  async deleteInstructor(t, s) {
    return e.delete(`${this.endpoint}/${t}/instructors/${s}`);
  }
  async addMainInstructor(t, s) {
    return e.put(`${this.endpoint}/${t}/main-instructors`, s);
  }
  async getUserCourse(t) {
    return e.get(`/user-courses/${t}`);
  }
  async getStudentReviews(t, s) {
    return e.get(
      `${this.endpoint}/${t}/students/${s}/reviews`
    );
  }
  async getStudentReviewNotes(t, s) {
    return e.get(
      `${this.endpoint}/${t}/students/${s}/review-notes`
    );
  }
  async getStudentCourse(t, s) {
    return e.get(
      `${this.endpoint}/${t}/students/${s}`
    );
  }
  async getCompletion(t) {
    return e.get(`${this.endpoint}/${t}/completion`);
  }
  async start(t) {
    return e.post(`${this.endpoint}/${t}/start`, {});
  }
  async pause(t) {
    return e.post(`${this.endpoint}/${t}/pause`, {});
  }
  async resume(t) {
    return e.post(`${this.endpoint}/${t}/resume`, {});
  }
  async confirmPracticalHearing(t) {
    return e.post(`${this.endpoint}/${t}/confirm-practical-hearing`, {});
  }
  async getUserCourses(t) {
    return e.get(`/users/${t}/notes`);
  }
  async updateCourseStatusForAdmin(t, s, i) {
    return e.post("/users/update-course-status", {
      id: t,
      courseId: s,
      status: i
    });
  }
  async addCourse(t, s) {
    return e.post("/user-courses", { courseId: t, userId: s });
  }
  async removeCourse(t, s) {
    return e.delete(`/user-courses/${s}/${t}`);
  }
}
const g = new p();
export {
  g as default
};
